require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-ilaria-giannetti-structure-and-architecture-in-dialogue-design-micronarratives-of-the-n-2-motorway-196186-attisholz-areal-riedholz-16-settembre-2021.json") })
        }
      }, "path---relazioni-e-conferenze-ilaria-giannetti-structure-and-architecture-in-dialogue-design-micronarratives-of-the-n-2-motorway-196186-attisholz-areal-riedholz-16-settembre-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-ilaria-giannetti-structure-and-architecture-in-dialogue-design-micronarratives-of-the-n-2-motorway-196186-attisholz-areal-riedholz-16-settembre-2021!./.cache/json/relazioni-e-conferenze-ilaria-giannetti-structure-and-architecture-in-dialogue-design-micronarratives-of-the-n-2-motorway-196186-attisholz-areal-riedholz-16-settembre-2021.json
// module id = 699
// module chunks = 231608221292675